import store from '../redux/store/redux';
// eslint-disable-next-line import/prefer-default-export

export const checkAccess = (appFeatureId) => {
  const state = store.getState();
 
  return true;
  // if(!state?.context?.userRightsAccess) {
  //   return true;
  // }
  

  //return state?.context?.userRightsAccess?.find(y => y.AppFeatureId === appFeatureId)?.AppFeatureValue === '1' || false;
};
